
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

/*const firebaseConfig = {
  apiKey: "AIzaSyDhO_VPnXzZP_yWoLGSx_K4gakbOcyqZyk",
  authDomain: "registro-life-ccm-pines-ad25.firebaseapp.com",
  projectId: "registro-life-ccm-pines-ad25",
  storageBucket: "registro-life-ccm-pines-ad25.firebasestorage.app",
  messagingSenderId: "250790046339",
  appId: "1:250790046339:web:a995cfb7ca4b88cbfe09b6"
};*/
const firebaseConfig = {
  apiKey: "AIzaSyA7vwUqhrfCpm1nK76wc-9NOLqYvqagZPs",
  authDomain: "micrositec-fd3ba.firebaseapp.com",
  projectId: "micrositec-fd3ba",
  storageBucket: "micrositec-fd3ba.firebasestorage.app",
  messagingSenderId: "234609458052",
  appId: "1:234609458052:web:62cecbbe1989b48f5cbbd1",
  measurementId: "G-K5S5XDP49F"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup };